import React, { Dispatch, SetStateAction } from 'react';

import { makeStyles } from 'tss-react/mui';
import { Typography } from 'web-library';
import { UploadedFile } from 'web-library/models/UploadedFile';
import UploadSupportingDocumentPassportPhoto from './UploadSupportingDocumentPassportPhoto';
import {
  AttachedFileType,
  NonNationalExamType,
  UploadDocumentType,
} from '../../../../api/candidate/config/model';

const useStyles = makeStyles()((theme) =>
({
  oneUploadSection: {
    marginBottom: theme.spacing(6),
  },
}));

interface SectionTitle {
  text: string;
  style: 'primary' | 'secondary';
}

interface Props {
  isAEIS: boolean;
  sectionTitle?: SectionTitle;
  noteContent?: JSX.Element;
  files: UploadedFile[];
  draftFiles: UploadedFile[];
  setFiles: Dispatch<SetStateAction<UploadedFile[]>>;
  setDraftFiles: Dispatch<SetStateAction<UploadedFile[]>>;
  isLoading: boolean;
  uploadDocumentType: UploadDocumentType;
  isFetchedDraft: boolean;
}

export const UploadAdditionalDocumentOneUploadSection = (props: Props) => {
  const {
    isAEIS,
    sectionTitle,
    noteContent,
    files,
    setFiles,
    draftFiles,
    setDraftFiles,
    isLoading,
    uploadDocumentType,
    isFetchedDraft,
  } = props;
  const { classes } = useStyles();

  return (
    <div className={classes.oneUploadSection}>
      <Typography
        // className={`${classes.sectionTitle} ${sectionTitle && sectionTitle.style === 'secondary' ? classes.titleSecondary : ''
        //   }`}
        variant="h3"
      >
        {sectionTitle && sectionTitle.text}
      </Typography>
      {noteContent}
      <UploadSupportingDocumentPassportPhoto
        files={files}
        setFiles={setFiles}
        applicationType={isAEIS ? NonNationalExamType.AEIS : NonNationalExamType.SPE}
        draftFiles={draftFiles}
        setDraftFiles={setDraftFiles}
        uploadDocumentType={uploadDocumentType}
        isLoading={isLoading}
        includeUploadedFiles={false}
        attachedFileType={AttachedFileType.APPLICATION_FILE}
        isFetchedDraft={isFetchedDraft}
      />
    </div>
  );
};

export default UploadAdditionalDocumentOneUploadSection;
